'use client';

import { authClient } from '@/lib/auth/client';
import { useWebHaptics } from 'web-haptics/react';
import { useCheckUserPlan } from '@/lib/neo/useCheckUserPlan';

import Image from 'next/image';
import Link from 'next/link';

import button from '@/styles/button.module.sass';
import text from '@/styles/text.module.sass';
import styles from './Profile.module.sass';

type AccountViewProps = {
  session: {
    user?: {
      id?: string;
      tid?: string;
      name?: string | null;
      image?: string | null;
    } | null;
  };
};

export default function AccountView({ session }: AccountViewProps) {
  const { trigger } = useWebHaptics();

  const userId = session?.user?.tid;
  const { planData, loading } = useCheckUserPlan(userId);

  return (
    <>
      <div className={styles.horizontalWrapper}>
        <h1 className={text.h1}>Hi,</h1>
        <Image
          className={styles.userImage}
          src={session.user?.image ?? '/images/seni-meets.png'}
          alt={session.user?.name ?? 'Unknown user'}
          width={48}
          height={48}
        />
        <h1 className={text.h1}>{session.user?.name ?? 'Unknown user'}</h1>
      </div>

      <p className={text.p}>
        <>
          Current plan -{' '}
          {loading ? (
            <span className={text.loading}>Loading...</span>
          ) : planData?.plan != null ? (
            String(planData.plan).charAt(0).toUpperCase() +
            String(planData.plan).slice(1).toLowerCase()
          ) : (
            '-'
          )}
          <br />
        </>

        {loading ? (
          <span className={text.loading}>Loading your plan...</span>
        ) : planData?.canCreateRoom != null ? (
          <>
            {planData.canCreateRoom
              ? 'You can create rooms'
              : 'Upgrade to Trinity or higher plan to create rooms'}
            <br />
          </>
        ) : null}
      </p>
      <div className={button.vWrapper}>
        <Link
          style={{ marginTop: '24px' }}
          className={button.accent}
          href="https://t.me/neovpn?start"
          target="_blank"
          onClick={() => trigger('medium')}
        >
          Manage subscription
        </Link>
        <button
          className={button.secondary}
          onClick={() => {
            void authClient.signOut();
            trigger('medium');
          }}
        >
          Sign out
        </button>
      </div>
    </>
  );
}
